// @flow

export const NEW_ZAP_ID = 'new-zap';

export const UPSELL_POLLING_EXPERIMENT = 'upsell-polling-exp3';
export const SHOW_UPSELL_POLLING_VARIANT = 'upsell';

export const EDITOR_ROUTE_PATH = 'app/editor';
export const TEMPLATE_ROUTE_PATH = 'template/:szid';
export const INSTANT_ROUTE_PATH = 'app/instant';
export const AUTH_INTENT_PARAM = 'intent';
export const AUTH_INTENT_ROUTE_MAP = {
  login: '/app/login/',
  signup: '/sign-up/',
};

export const FILTER_DESCRIPTION =
  'Choose the condition(s) your data should meet to continue to run';

export const PATH_LABELS = {
  path: 'Path Name',
  rules: 'Path Rules',
};

export const PATH_DESCRIPTIONS = {
  path: 'Give your path a name.',
  rules: 'Set the conditions for your path to run.',
};

export const ZT_ROUTE_PATH = 'zap-template';

export const ZT_ASSIGN_PROP = { isZapTemplate: true };
export const ZT_API_NAMESPACE = 'is_template';
export const ZT_API_PARAM = { [ZT_API_NAMESPACE]: true };
export const ZAPIER_META_KEY_PREFIX = '_zap_data_';
export const ZT_LIVE_DATA_SERVICES = ['ZapierFormatterDevAPI', 'CodeAPI'];

export const TRIGGER = 'Trigger';
export const ACTION = 'Action';
export const PATH_DETAILS = 'Path Details';
export const SEARCH = 'Search';

export const STEP_TYPE_ICONS = {
  [TRIGGER]: 'target',
  [ACTION]: 'bolt',
  [SEARCH]: 'search',
  [PATH_DETAILS]: 'path',
};

// path settings page key
export const PATH_SETTINGS_PAGE = 'path';

export const PATHS_DEPTH_LIMIT_MSG =
  'At the moment, we’re only allowing Paths that are nested ';
export const PATHS_DEPTH_LIMIT_LEVELS_DEEP_MSG = ' levels deep.';

export const PATHS_HELP_URL =
  '/help/create/customize/add-branching-logic-to-zaps-with-paths';
export const PATHS_HOW_MANY_IN_GROUP_HELP_URL =
  '/help/create/customize/how-many-paths-can-be-placed-path-group';
export const PATHS_VIDEO_URL = 'https://www.youtube.com/watch?v=3Ij0TcKNGdk';
export const PATHS_GETTING_STARTED_URL =
  '/help/create/customize/add-branching-logic-to-zaps-with-paths';

export const SIMPLIFIED_HEADER_TXT_TRIGGER = 'When this happens …';
export const SIMPLIFIED_HEADER_TXT_ACTION = 'Do this …';
export const SIMPLIFIED_HEADER_TXT_FINISH = 'Finish Up Your Zap';

export const SET_UP_NEXT_PATH = 'Set Up Next Path';

export const PATHS_NOT_AVAILABLE_MSG =
  'Paths are only available in the classic editor.';

export const DEFAULT_CLASSIC_STEP_LABEL = 'Set up this step';
export const DEFAULT_BETA_TRIGGER_LABEL = 'When This Happens ...';
export const DEFAULT_BETA_ACTION_LABEL = 'Do This ...';

export const BRANCH_OVERVIEW_PAGE_KEY = 'overview';
